module.exports = __webpack_public_path__ + "img/active-layer10.54a027e2.png";